import { put, takeLatest, call } from 'redux-saga/effects';
import types from '../../types';
import api from '../../../services/api';
import notification from '../../../services/notification';

function* getUserSecurityOptions({ payload }) {
  try {
    const { data, status } = yield call(api.profile.getUserSecurityOptions, payload);
    if (status < 200 || status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.GET_USER_SECURITY_OPTIONS_SUCCESS, payload: data });
  } catch (error) {
    yield put({ type: types.GET_USER_SECURITY_OPTIONS_FAILURE });
    if (error?.response?.status === 401) return;
    notification({ type: 'error', message: 'Something went wrong' });
  }
}

function* putUserSecurityOptions({ payload }) {
  try {
    const { data, status } = yield call(api.profile.putUserSecurityOptions, payload);
    if (status < 200 || status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.PUT_USER_SECURITY_OPTIONS_SUCCESS });

    yield put({ type: types.GET_USER_SECURITY_OPTIONS_START, payload });

    notification({
      type: 'success',
      title: 'Security',
      message: 'Success. Session settings has been changed',
    });
  } catch (error) {
    yield put({ type: types.PUT_USER_SECURITY_OPTIONS_FAILURE });
    if (error?.response?.status === 401) return;
    notification({ type: 'error', message: 'Something went wrong' });
  }
}

function* putResetWithdrawalUserSecretPhrase({ payload }) {
  try {
    const { data, status } = yield call(
      api.profile.putResetWithdrawalUserSecretPhrase,
      payload,
    );
    if (status < 200 || status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.RESET_WITHDRAWAL_SECRET_PHRASE_SUCCESS });

    yield put({ type: types.GET_USER_SECURITY_OPTIONS_START, payload });

    notification({
      type: 'success',
      title: 'Security',
      message: 'Success. Session settings has been changed',
    });
  } catch (error) {
    yield put({ type: types.RESET_WITHDRAWAL_SECRET_PHRASE_FAILURE });
    if (error?.response?.status === 401) return;
    notification({ type: 'error', message: 'Something went wrong' });
  }
}

function* getUserUniqueDevices({ payload }) {
  try {
    const { data, status } = yield call(api.profile.getUserUniqueDevices, payload);
    if (status < 200 || status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.GET_USER_UNIQUE_DEVICES_SUCCESS, payload: data });
  } catch (error) {
    yield put({ type: types.GET_USER_UNIQUE_DEVICES_FAILURE });
    if (error?.response?.status === 401) return;
    notification({ type: 'error', message: 'Something went wrong' });
  }
}

function* deleteUserUniqueDevice({ payload }) {
  try {
    const { data, status } = yield call(api.profile.deleteUserUniqueDevice, payload);
    if (status < 200 || status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.DELETE_USER_UNIQUE_DEVICE_SUCCESS, payload });
  } catch (error) {
    yield put({ type: types.DELETE_USER_UNIQUE_DEVICE_FAILURE });
    if (error?.response?.status === 401) return;
    notification({ type: 'error', message: 'Something went wrong' });
  }
}

function* getUserWithdrawalWhiteAddresses({ payload }) {
  try {
    const { data, status } = yield call(
      api.profile.getUserWithdrawalWhiteAddresses,
      payload,
    );
    if (status < 200 || status >= 300) throw new Error('Something went wrong');
    yield put({
      type: types.GET_USER_WITHDRAWAL_WHITELIST_ADDRESSES_SUCCESS,
      payload: data,
    });
  } catch (error) {
    yield put({ type: types.GET_USER_WITHDRAWAL_WHITELIST_ADDRESSES_FAILURE });
    if (error?.response?.status === 401) return;
    notification({ type: 'error', message: 'Something went wrong' });
  }
}

export function* userSecurity() {
  yield takeLatest(types.GET_USER_SECURITY_OPTIONS_START, getUserSecurityOptions);
  yield takeLatest(types.PUT_USER_SECURITY_OPTIONS_START, putUserSecurityOptions);
  yield takeLatest(
    types.RESET_WITHDRAWAL_SECRET_PHRASE_START,
    putResetWithdrawalUserSecretPhrase,
  );
  yield takeLatest(types.GET_USER_UNIQUE_DEVICES_START, getUserUniqueDevices);
  yield takeLatest(types.DELETE_USER_UNIQUE_DEVICE_START, deleteUserUniqueDevice);
  yield takeLatest(
    types.GET_USER_WITHDRAWAL_WHITELIST_ADDRESSES_START,
    getUserWithdrawalWhiteAddresses,
  );
}
